



















































































import {Component, Prop, Vue} from "vue-property-decorator";
import {FormModel} from "ant-design-vue";
import {FreightServiceAddStore} from "@/modules/freightserviceadds/store";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import {assignValueToForm} from "@/shared/services/helper/utils";
import {CommonStatus} from "@/enums/status";
import PriceListSelector from "@/shared/components/PriceListSelector/index.vue";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import PostOfficeSelector from "@/shared/components/PostOfficeSelector/index.vue";
import { cloneDeep } from 'lodash';
import InputCurrency from "@/shared/components/InputCurrency/index.vue";
import AInputCustom from "@/shared/components/CustomInputAnt/index.vue";

const form = {
    rowGuid: undefined,
    code: undefined,
    name: undefined,
    allowanceReceiver: 0,
    allowanceDelivery: 0,
    fee: 0,
    note: undefined,
    postOfficeRowGuid: undefined,
    status: undefined
};
@Component({
    name: "FreightServiceForm",
    components: {AInputCustom, InputCurrency, PostOfficeSelector, PriceListSelector, EnumSelector},
})
export default class extends mixins(CommonMixin) {
    @Prop()
    readonly id!: string;
    
    CommonStatus = CommonStatus;
    private form = cloneDeep(form);

    private rules = {
        rowGuid: undefined,
        code: [{ required: true, message: "Nhập mã dịch vụ", trigger: "change" }],
        name: [{ required: true, message: "Nhập tên dịch vụ", trigger: "change" }],
        allowanceReceiver: [{ required: true, message: "Nhập phụ cấp nhận", trigger: "change" }],
        allowanceDelivery: [{ required: true, message: "Nhập phụ cấp giao", trigger: "change" }],
        fee: [{ required: true, message: "Nhập cước", trigger: "change" }],
        note: undefined,
        postOfficeRowGuid: undefined
    };

    private onSubmit() {
        (this.$refs.formFreightServiceAdd as FormModel).validate(async valid => {
            if (!valid) return;
            try {
                this.id
                    ? await FreightServiceAddStore.updateFreightServiceAdd(this.form)
                    : await FreightServiceAddStore.createFreightServiceAdd(this.form);
                this.$message.success({
                    content: `${this.id ? 'Sửa' : 'Tạo'} dịch vụ thành công`
                });
                this.$router.push({ name: "listFreightServiceAdd" });
            } catch (e) {
                this.$message.error({
                    content: `${e.response?.data?.message || `${this.id ? 'Sửa' : 'Tạo'} dịch vụ thất bại`}`
                })
            }
        })
    }

    async created() {
        if (this.id) {
            try {
                const data = await FreightServiceAddStore.singleFreightServiceAdd(this.id);
                this.form = assignValueToForm(this.form, data);
            } catch (e) {
                this.$message.error({
                    content: `${e.response?.data?.message || "Đã có lỗi xảy ra"}`
                })
            }
        }
    }
}
